import { Injectable } from '@angular/core';
import { Product } from '@shared/models/product';
import { FormControl } from '@angular/forms';
import { CostCenterSelectionService } from '@sharedComponents/dialogs/cost-center-selection/cost-center-selection.service';

@Injectable({providedIn: 'root'})
export class InvoicePositionDialogService {

    constructor(
        private costCenterSelectionService: CostCenterSelectionService
    ) {
    }

    public checkForCostCenterAvailability(product: Product, costCenterControl: FormControl, promptOnMultiple = true) {
        if (costCenterControl?.value
            || !(product instanceof Product)
            || !product?.costCenters?.length) {
            return;
        }

        this.costCenterSelectionService
            .resolve(product, promptOnMultiple)
            .subscribe(costCenter => {
                if (costCenter) {
                    costCenterControl.setValue(costCenter);
                }
            });
    }
}
